import React, { useEffect, useRef } from 'react';
import CompMarquee from '../Components/CompMarquee';
import CompContentBlock from '../Components/CompContentBlock';
import './InnovationEngine.css';
import { Grid } from '@mui/material';
import CompContactWidget from '../Components/CompContactWidget';

const InnovationEngine = () => {
  // Ref for the HubSpot form container
  const hubspotFormRef = useRef(null);

  useEffect(() => {
    // No HubSpot form or script here anymore

    // HubSpot form embed
    const scriptId = 'hs-form-script';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.src = '//js.hsforms.net/forms/embed/v2.js';
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.id = scriptId;
      script.onload = () => {
        if (window.hbspt) {
          window.hbspt.forms.create({
            portalId: "44366894",
            formId: "661d487d-1d34-4af8-b84b-ddc505bf00bd",
            region: "na1",
            target: '#hubspotForm'
          });
        }
      };
      document.body.appendChild(script);
    } else if (window.hbspt) {
      window.hbspt.forms.create({
        portalId: "44366894",
        formId: "661d487d-1d34-4af8-b84b-ddc505bf00bd",
        region: "na1",
        target: '#hubspotForm'
      });
    }
  }, []);

  return (
    <div className="startups-and-products-container">
      <CompMarquee title="Innovation Engine" subTitle="Connect, found, grow." />

      {/* Section 1 */}
      <div>
        <CompContentBlock
          heading="Join us as a Founding Member for No Cost"
          subheading="Be an early member of the newest innovation community."
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <img
                src="https://images.unsplash.com/photo-1465101046530-73398c7f28ca?auto=format&fit=crop&w=400&q=80"
                alt="Our Mission"
                width={400}
                height={267}
                style={{ width: '100%', height: 'auto' }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <h4>A New Community Just for Innovators</h4>
              <p>
                Innovators always needed a dedicated space to connect, collaborate, and grow. Innovation Engine is that
                space. It's an upcoming vibrant community where innovators from all walks of life can come together to
                share ideas, find resources, and turn their visions into reality. Whether you're an entrepreneur, a
                developer, a designer, or simply someone with a passion for innovation, Innovation Engine provides the
                tools and support you need to succeed.
              </p>
            </Grid>
          </Grid>
        </CompContentBlock>
      </div>

      {/* Section 2 */}
      <div>
        <CompContentBlock
          heading="Areas of Focus for the Community"
          subheading="Multiple ways to engage with your peers."
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <img
                src="https://images.unsplash.com/photo-1461749280684-dccba630e2f6?auto=format&fit=crop&w=400&q=80"
                alt="Collaboration"
                width={400}
                height={267}
                style={{ width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '8px' }}
              />
              <h3>Collaborate with Innovators</h3>
              <p>
                Collaboration is at our core. Connect with innovators, share ideas, and find partners to help your
                projects grow.
              </p>
            </Grid>
            <Grid item xs={12} md={3}>
              <img
                src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=400&q=80"
                alt="Hackathon"
                width={400}
                height={267}
                style={{ width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '8px' }}
              />
              <h3>Join a Hackathon</h3>
              <p>
                Hackathons connect innovators to solve real problems fast. Build, learn, and network with peers in a
                dynamic setting.
              </p>
            </Grid>
            <Grid item xs={12} md={3}>
              <img
                src="https://images.unsplash.com/photo-1503676382389-4809596d5290?auto=format&fit=crop&w=400&q=80"
                alt="Workshop"
                width={400}
                height={267}
                style={{ width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '8px' }}
              />
              <h3>Attend or Host a Workshop</h3>
              <p>
                Dive into topics, learn new skills, or share your expertise. Workshops are interactive spaces for
                growth and connection.
              </p>
            </Grid>
            <Grid item xs={12} md={3}>
              <img
                src="https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=400&q=80"
                alt="Industry Niches"
                width={400}
                height={267}
                style={{ width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '8px' }}
              />
              <h3>Industry Niches</h3>
              <p>
                Join focused groups like low code or AI/ML to connect, share knowledge, and collaborate on specialized
                projects.
              </p>
            </Grid>
          </Grid>
        </CompContentBlock>
        {/* Section 3 */}
        <CompContentBlock
          heading="Get Involved Today"
          subheading="Become a founding member and shape the future of innovation."
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={3}>
              <img
                src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?auto=format&fit=crop&w=400&q=80"
                alt="Community Collaboration"
                width={400}
                height={267}
                style={{ width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '8px' }}
              />
              <h5 style={{ marginTop: '10px' }}>Become a Founding Member</h5>
              <p>
                Join a community of innovators and help shape the future. As a founding member, your voice and ideas
                will help guide our direction from day one.
              </p>
            </Grid>
            <Grid item xs={12} md={9}>
              {/* HubSpot form embedded here */}
              <div style={{ background: '#fff', padding: '20px', width: '100%' }}>
                <div id="hubspotForm" ref={hubspotFormRef}></div>
              </div>
            </Grid>
          </Grid>
        </CompContentBlock>
      </div>
    </div>
  );
};

export default InnovationEngine;
